import React from "react";
const VectorLayerContext = new React.createContext();
export default VectorLayerContext;